import { http } from 'vue'
let r1 = false
let r2 = false
let r3 = false
let r4 = false
let r5 = false
let r6 = false
let r7 = false
let resource = 'announcements'
export default {
  loadAnnouncements (context, params = {}) {
    let page = '?page=' + (params.page ? params.page : '1')
    let skuId = (params.skuId) ? '&sku_id=' + params.skuId : ''
    let companyId = (params.companyId) ? '&company_id=' + params.companyId : ''
    let forCatalog = (params.forCatalog) ? '&for_catalog=' + params.forCatalog : ''
    return http.get(resource + page + companyId + skuId + forCatalog, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  },
  loadAnnouncement (context, params = {}) {
    return http.get(resource + '/' + params.id, {
      before (request) {
        if (r2) r2.abort()
        r2 = request
      }
    })
  },
  postAnnouncement (context, params = {}) {
    return http.post(resource, params.data, {
      before (request) {
        if (r3) r3.abort()
        r3 = request
      }
    })
  },
  putAnnouncement (context, params = {}) {
    return http.put(resource + '/' + params.id, params.data, {
      before (request) {
        if (r4) r4.abort()
        r4 = request
      }
    })
  },
  deleteAnnouncement (context, params = {}) {
    return http.delete(resource + '/' + params.id, {
      before (request) {
        if (r5) r5.abort()
        r5 = request
      }
    })
  },
  loadShoppingAnnouncements (context, params = {}) {
    let page = '?page=' + (params.page ? params.page : '1')
    let categoryId = '&category_id=' + (params.categoryId ? params.categoryId : '1')
    let subcategoryId = (params.subcategoryId) ? '&subcategory_id=' + params.subcategoryId : ''
    let productId = (params.productId) ? '&product_id=' + params.productId : ''
    let skuId = (params.skuId) ? '&sku_id=' + params.skuId : ''
    let cityId = (params.cityId) ? '&city_id=' + params.cityId : ''
    let brandId = (params.brandId) ? '&brand_id=' + params.brandId : ''
    let warranty = (params.warranty) ? '&warranty=' + params.warranty : ''
    let reviewed = (params.reviewed) ? '&reviewed=' + params.reviewed : ''
    let state = (params.state) ? '&state=' + params.state : ''
    return http.get('shopping/' + resource + page + categoryId + subcategoryId + productId + skuId + cityId + brandId + warranty + reviewed + state, {
      before (request) {
        if (r6) r6.abort()
        r6 = request
      }
    })
  },
  loadShoppingMenu (context, params = {}) {
    let categoryId = '?category_id=' + (params.categoryId ? params.categoryId : '1')
    let subcategoryId = (params.subcategoryId) ? '&subcategory_id=' + params.subcategoryId : ''
    let productId = (params.productId) ? '&product_id=' + params.productId : ''
    let skuId = (params.skuId) ? '&sku_id=' + params.skuId : ''
    let cityId = (params.cityId) ? '&city_id=' + params.cityId : ''
    let brandId = (params.brandId) ? '&brand_id=' + params.brandId : ''
    let warranty = (params.warranty) ? '&warranty=' + params.warranty : ''
    let reviewed = (params.reviewed) ? '&reviewed=' + params.reviewed : ''
    let state = (params.state) ? '&state=' + params.state : ''
    return http.get('shopping/menu' + categoryId + subcategoryId + productId + skuId + cityId + brandId + warranty + reviewed + state, {
      before (request) {
        if (r7) r7.abort()
        r7 = request
      }
    })
  },
  loadShoppingAnnouncement (context, params = {}) {
    return http.get('shopping/' + resource + '/' + params.id, {
      before (request) {
        if (r7) r7.abort()
        r7 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/announcements/actions.js